import React from 'react';
import Layout from '../../components/Layout';
import ActivityView from './ActivityView';
import { ROLE_SUPER_ADMIN, ROLE_EXECUTIVE_ADMIN } from '../../constants';

const title = 'Activity View';

function action({ store, fetch }, { id }) {
  const state = store.getState();
  const roleId = state.auth.user.role_id;
  const getActivityAsync = async () => {
    const resp = await fetch(`/api/activity/${id}`, {
      method: 'GET'
    });
    const activityData = await resp.json();
    if (activityData) {
      const activity = activityData.json_content;
      activity.id = activityData.id;
      activity.visible = activityData.visible;
      activity.image = activityData.photos.map(
        photo => ({
          id: photo.id,
          photo: !photo.json_info.image.startsWith('data') &&
          !photo.json_info.image.startsWith('/uploads')
            ? `/uploads/${photo.json_info.image}`
            : photo.json_info.image
        })
      );

      if (!activity.visible) {
        return Promise.reject('not visible');
      }

      return {
        chunks: ['activityView'],
        title,
        component: (
          <Layout>
            <ActivityView
              isAdmin={
                roleId === ROLE_SUPER_ADMIN || roleId === ROLE_EXECUTIVE_ADMIN
              }
              title={title}
              activity={activity}
            />
          </Layout>
        )
      };
    }
    return Promise.reject('bad url');
  };
  return getActivityAsync().catch(() => ({ redirect: '/not-found' }));
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/activityView/index.js